module.exports = __webpack_public_path__ + "static/img/40.6ea0141f.png";